import React, { useState } from "react";
import { withRouter } from "react-router";
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from "../../actions/authentification";
import { SET_IS_DARK } from "../../actions/types";
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Avatar, Button, Link, Toolbar, Tooltip, MenuItem, Menu, Fade, Switch } from '@material-ui/core';
import logo2 from '../../images/ggcLogo2.png';
import { MenuDown } from 'mdi-material-ui';

const useStyles = makeStyles((theme) => ({
    appBar: {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    avatar: {
        marginLeft: 10,
        color: 'white',
        backgroundColor: '#48ab3f'
    },
    toolbar: {
        flexWrap: 'nowrap',
        flexDirection: 'row',
        width: '100%',
    },
    logoContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginLeft: 10
    },
    navsContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        width: '90%',
        justifyContent: 'flex-end',
    },
    navItems: {
        margin: 0,
        paddingRight: 40,
    },

    //override default hover effect
    navItemButton: {
        "&:hover": {
            backgroundColor: "transparent"
        },
        fontWeight: 600,
        fontSize: 14,
        textAlign: 'center',
        color: theme.palette.grey[500],
        width: 110,
        marginLeft: 20,
    },
    navItemButtonActive: {
        //"&:hover": {
        //    backgroundColor: "transparent"
        //},
        fontWeight: 600,
        //borderStyle: 'none solid none solid',
        //borderWidth: 0.5,
        //borderColor: 'rgba(189, 195, 199, 0.6)',
        //borderRadius: '0px',
        fontSize: 14,
        textAlign: 'center',
        color: theme.palette.type === 'light' ? theme.palette.grey[800] : theme.palette.grey[200],
        width: 110,
        marginLeft: 20,
    },
    menuButtonEndIcon: {
        marginLeft: 0,
        marginRight: 20
    },
    link: {
        margin: theme.spacing(1, 1.5),
    },
    loginButton: {
        margin: theme.spacing(1, 1.5),
    },
    cardHeader: {
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
    },
    footer: {
        borderTop: `1px solid ${theme.palette.divider}`,
        marginTop: theme.spacing(8),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(6),
        },

    },
}));

const TopMenu = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const classes = useStyles();
    const userStore = useSelector((state) => state.authentification);
    const isDark = useSelector((state) => state.theme.isDark);
    const appliedPermissions = useSelector((state) => state.privilegeManager.appliedPermissions)

    const [tankAnchor, setTankAnchor] = useState(null);
    const [adminAnchor, setAdminAnchor] = useState(null);
    const [purchaseAnchor, setPurchaseAnchor] = useState(null);
    const [transferAnchor, setTransferAnchor] = useState(null);
    const [saleAnchor, setSaleAnchor] = useState(null);
    const [planningAnchor, setPlanningAnchor] = useState(null);
    const [userAnchor, setUserAnchor] = useState(null);
    const [themeIsDark, setThemeIsDark] = useState(isDark);

    const isTransporter = JSON.parse(localStorage.getItem('user'))?.isTransporter === 'T';

    let linksAllowed;
    if (appliedPermissions.length > 0) {
        linksAllowed = appliedPermissions.filter(x => x.value === "1").map(z => isTransporter ? (z.key == '6' ? '6' : '') : z.key)
    } else {
        linksAllowed = []
    }

    //#region HANDLE MENU "TABS"
    let activePage;
    switch (location.pathname) {
        case '/tank/tank-midnight/home':
        case '/tank/tank-midnight/create':
        case '/tank-summary/home':
            activePage = 'tank'
            break;
        case '/transfer/transfer-at-source':
        case '/transfer/transfer-at-source/create':
            activePage = 'transfer'
            break;
        case '/sale/sale-at-external/home':
        case '/sale/sale-report/home':
            activePage = 'sale'
            break;
        case '/admin/user-manager/home':
        case '/admin/user-manager/manage':
        case '/admin/role-master/home':
        case '/admin/role-master/manage':
        case '/admin/privilege-manager':
        case '/admin/operation-team-master/home':
        case '/admin/operation-team-master/manage':
        case '/admin/email-group/home':
        case '/admin/email-group/manage':
        case '/admin/email-audit/home':
        case '/admin/email-audit/details':
            activePage = 'admin'
            break;
        case '/purchase/material-receiving/home':
        case '/purchase/material-receiving/create':
            activePage = 'purchase'
            break;
        case '/planning/plan-management/manage':
        case '/planning/plan-management/dashboard':
            activePage = 'planning'
            break;
        case '/':
            activePage = null
        default:
    }
    //#endregion

    //Change theme
    const handleChangeTheme = (event) => {
        setThemeIsDark(!themeIsDark)
        dispatch({
            type: SET_IS_DARK,
            payload: !isDark,
        });
    }
    //Tank menu open/close handlers
    const handleClickTank = (event) => {
        setTankAnchor(event.currentTarget);
    };
    const handleCloseTank = () => {
        setTankAnchor(null);
    };

    //Admin menu open/close handlers
    const handleClickAdmin = (event) => {
        setAdminAnchor(event.currentTarget);
    };
    const handleCloseAdmin = () => {
        setAdminAnchor(null);
    };

    //Purchase menu open/close handlers
    const handleClickPurchase = (event) => {
        setPurchaseAnchor(event.currentTarget);
    };
    const handleClosePurchase = () => {
        setPurchaseAnchor(null);
    };

    //Transfer menu open/close handlers
    const handleClickTransfer = (event) => {
        setTransferAnchor(event.currentTarget);
    };
    const handleCloseTransfer = () => {
        setTransferAnchor(null);
    };

    //Sale menu open/close handlers
    const handleClickSale = (event) => {
        setSaleAnchor(event.currentTarget);
    };
    const handleCloseSale = () => {
        setSaleAnchor(null);
    };

    //User menu open/close handlers
    const handleClickUser = (event) => {
        setUserAnchor(event.currentTarget);
    };
    const handleCloseUser = () => {
        setUserAnchor(null);
    };

    //Planning menu open/close handlers
    const handleClickPlanning = (event) => {
        setPlanningAnchor(event.currentTarget);
    };
    const handleClosePlanning = () => {
        setPlanningAnchor(null);
    };
    
    //SignOut
    const onClickSignOut = async () => {
        dispatch(logout());
    }

    return (
        <AppBar position="static" color="default" elevation={2} className={classes.appBar}>
            <Toolbar className={classes.toolbar}>
                <div className={classes.logoContainer}>
                    <Link variant="button" onClick={() => history.push("/")}>
                        <img style={{ minWidth: 80, maxWidth: 130 }} src={logo2} alt="PTT GGC" />
                    </Link>

                </div>
                <div className={classes.navsContainer}>


                    <div className={classes.navItems} >
                        {linksAllowed.includes("1") ?
                            <Button
                                className={activePage === 'purchase' ? classes.navItemButtonActive : classes.navItemButton}
                                id="purchase-button"
                                variant="text"
                                disableRipple
                                onClick={handleClickPurchase}
                                endIcon={<MenuDown className={classes.menuButtonEndIcon} />}
                            >
                                Purchase
                        </Button>

                            : null
                        }
                        <Menu
                            id="purchase-menu-items"
                            anchorEl={purchaseAnchor}
                            getContentAnchorEl={null}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                            keepMounted
                            open={Boolean(purchaseAnchor)}
                            onClose={handleClosePurchase}
                        >
                            <MenuItem
                                onClick={() => {
                                    history.push("/purchase/material-receiving/home")
                                    handleClosePurchase()
                                }
                                }>
                                Material Receiving
                            </MenuItem>

                            {/*<MenuItem onClick={() => {*/}
                            {/*    history.push("/purchase/material-receiving/create")*/}
                            {/*    handleClosePurchase()*/}
                            {/*}*/}
                            {/*}> Material Receiving Create*/}
                            {/*</MenuItem>*/}
                        </Menu>



                        {linksAllowed.includes("2") ?
                            <Button
                                className={activePage === 'transfer' ? classes.navItemButtonActive : classes.navItemButton}
                                id="transfer-button"
                                variant="text"
                                //onClick={handleClickExternalStorage}
                                disableRipple
                                onClick={handleClickTransfer}
                                endIcon={<MenuDown className={classes.menuButtonEndIcon} />}
                            >
                                Transfer
                        </Button>
                            : null
                        }
                        <Menu
                            id="transfer-menu-items"
                            anchorEl={transferAnchor}
                            getContentAnchorEl={null}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                            keepMounted
                            open={Boolean(transferAnchor)}
                            onClose={handleCloseTransfer}
                        >
                            <MenuItem
                                onClick={() => {
                                    history.push("/transfer/transfer-at-source")
                                    handleCloseTransfer()
                                }
                                }>
                                Transfer At Source
                            </MenuItem>

                            {/*<MenuItem onClick={() => {*/}
                            {/*    history.push("/transfer/transfer-at-source/create")*/}
                            {/*    handleCloseTransfer()*/}
                            {/*}*/}
                            {/*}> Transfer At Source Create*/}
                            {/*</MenuItem>*/}
                        </Menu>



                        {linksAllowed.includes("3") ?
                            <Button
                                className={activePage === 'sale' ? classes.navItemButtonActive : classes.navItemButton}
                                id="sale-button"
                                variant="text"
                                onClick={handleClickSale}
                                disableRipple
                                endIcon={<MenuDown className={classes.menuButtonEndIcon} />}
                            >
                                Sale
                        </Button>
                            : null
                        }
                        <Menu
                            id="sale-menu-items"
                            anchorEl={saleAnchor}
                            getContentAnchorEl={null}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                            keepMounted
                            open={Boolean(saleAnchor)}
                            onClose={handleCloseSale}
                        >
                            <MenuItem
                                onClick={() => {
                                    history.push("/sale/sale-at-external/home")
                                    handleCloseSale()
                                }
                                }>
                                Sale At External
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    history.push("/sale/sale-report/home")
                                    handleCloseSale()
                                }
                                }>
                                Sale Report
                            </MenuItem>
                        </Menu>



                        {linksAllowed.includes("4") ?
                            <Button
                                className={activePage === 'tank' ? classes.navItemButtonActive : classes.navItemButton}
                                id="tank-button"
                                variant="text"
                                onClick={handleClickTank}
                                disableRipple
                                endIcon={<MenuDown className={classes.menuButtonEndIcon} />}>
                                Tank
                        </Button>
                            : null
                        }

                        <Menu
                            id="tank-menu-items"
                            anchorEl={tankAnchor}
                            getContentAnchorEl={null}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                            keepMounted
                            open={Boolean(tankAnchor)}
                            onClose={handleCloseTank}
                        >
                            <MenuItem
                                onClick={() => {
                                    history.push("/tank/tank-midnight/home")
                                    handleCloseTank()
                                }
                                }>
                                Tank Midnight
                            </MenuItem>
                        </Menu>


                        {linksAllowed.includes("6") ?
                            <Button
                                className={activePage === 'planning' ? classes.navItemButtonActive : classes.navItemButton}
                                id="planning-button"
                                variant="text"
                                onClick={handleClickPlanning}
                                disableRipple
                                endIcon={<MenuDown className={classes.menuButtonEndIcon} />}
                            >
                                Planning
                            </Button>
                            : null
                        }
                        <Menu
                            id="planning-menu-items"
                            anchorEl={planningAnchor}
                            getContentAnchorEl={null}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                            keepMounted
                            open={Boolean(planningAnchor)}
                            onClose={handleClosePlanning}
                        >
                            <MenuItem
                                onClick={() => {
                                    history.push("/planning/plan-management/manage")
                                    handleClosePlanning()
                                }
                                }>
                                Planning
                            </MenuItem>

                            <MenuItem onClick={() => {
                                history.push("/planning/plan-management/dashboard")
                                handleClosePlanning()
                            }
                            }> Dashboard </MenuItem>

                        </Menu>


                        {linksAllowed.includes("5") ?
                            <Button
                                className={activePage === 'admin' ? classes.navItemButtonActive : classes.navItemButton}
                                id="admin-button"
                                variant="text"
                                onClick={handleClickAdmin}
                                disableRipple
                                endIcon={<MenuDown className={classes.menuButtonEndIcon} />}>
                                Admin
                        </Button>
                            : null
                        }

                        <Menu
                            id="admin-menu-items"
                            anchorEl={adminAnchor}
                            getContentAnchorEl={null}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                            keepMounted
                            open={Boolean(adminAnchor)}
                            onClose={handleCloseAdmin}
                        >
                            <MenuItem
                                onClick={() => {
                                    history.push("/admin/user-manager/home")
                                    handleCloseAdmin()
                                }
                                }>
                                User Manager </MenuItem>

                            <MenuItem onClick={() => {
                                history.push("/admin/privilege-manager")
                                handleCloseAdmin()
                            }
                            }> Privilege Manager </MenuItem>

                            <MenuItem onClick={() => {
                                history.push("/admin/role-master/home")
                                handleCloseAdmin()
                            }
                            }> Role Master </MenuItem>

                            <MenuItem onClick={() => {
                                history.push("/admin/operation-team-master/home")
                                handleCloseAdmin()
                            }
                            }> Operation Team Master </MenuItem>

                            {/*<MenuItem onClick={() => {*/}
                            {/*    history.push("/admin/email-group/home")*/}
                            {/*    handleCloseAdmin()*/}
                            {/*}*/}
                            {/*}> Email Groups </MenuItem>*/}
                            {/*<MenuItem onClick={() => {*/}
                            {/*    history.push("/admin/email-audit/home")*/}
                            {/*    handleCloseAdmin()*/}
                            {/*}*/}
                            {/*}> Email Audit </MenuItem>*/}
                        </Menu>

                    </div>
                </div>

                <nav className={classes.navs}>
                    <Button
                        className={classes.navItemButton}
                        id="userMenuButton"
                        variant="text"
                        onClick={handleClickUser}
                        disableRipple
                        endIcon={<MenuDown style={{ marginLeft: 6 }} />}>
                        {userStore.user.firstName}
                    </Button>
                    <Menu
                        id="userMenuItems"
                        anchorEl={userAnchor}
                        getContentAnchorEl={null}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                        keepMounted
                        open={Boolean(userAnchor)}
                        onClose={handleCloseUser}
                        TransitionComponent={Fade}
                    >
                        <MenuItem onClick={onClickSignOut} >Logout</MenuItem>
                    </Menu>
                </nav>
                <Avatar alt={userStore.user.firstName} src={`data:image/jpeg;base64,${userStore.user.profilePic}`} className={classes.avatar} />
                <Tooltip title='Change theme'>
                    <Switch size='small' color='primary' checked={themeIsDark} onChange={handleChangeTheme} />
                </Tooltip>
            </Toolbar>
        </AppBar>
    );
}

// Attach the React Router to the component to have an opportunity
// to interract with it: use some navigation components, 
// have an access to React Router fields in the component's props, etc.
export default withRouter(TopMenu);